import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M2.25 12.764c0 1.601 1.123 2.995 2.707 3.228q1.603.235 3.238.364a1.53 1.53 0 0 1 1.153.67L12 21.006l2.652-3.978c.26-.39.687-.634 1.153-.671a48 48 0 0 0 3.238-.364c1.584-.233 2.707-1.627 2.707-3.228v-6.02c0-1.6-1.123-2.995-2.707-3.227A48.4 48.4 0 0 0 12 3.005c-2.392 0-4.744.175-7.043.513C3.373 3.75 2.25 5.144 2.25 6.745z"
    }, null, -1)
  ])))
}
export default { render: render }